import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Fade } from '../../animation/animation';

import { setError, resetError } from '../../reducers/main/main.actions';
import ErrorMessage from '../error-message/error-message';
import Button from '../button/button';
import Agreement from '../agreement/agreement';
import CallTimeUnderPhone from '../call-time-under-phone/call-time-under-phone';
import { CallTimeFormRegime } from '../../models/call-time-form-regime.model';
import { PhoneFormData } from '../../interfaces/phone-form-data.interface';
import { InputField } from '../input-field/input-field';
import { phoneFormActions } from '../../reducers/phone-form/phone-form.actions';
import { AGREEMENT_ERROR, EMPTY_PHONE_ERROR, EVENT_START_TYPING_PHONE, INCORRECT_PHONE_ERROR, PHONE_LENGTH_ERROR, PHONE_REQUIRED_LENGTH } from '../../constants';
import { RootState } from '../../store';
import { useMediaQuery } from 'react-responsive';
import { ReactElement } from 'react-imask/dist/mixin';
import CustomAgreement from '../agreement/custom-agreement';
import { emitEvent } from '../../event-emitter';

interface PhoneFormProps {
	active: boolean
	button: string
	struct?: 'default' | 'inline'
	callTimeFormRegime?: CallTimeFormRegime
	placeholder?: string,
  phoneInputType?: {
    padding: string;
    border: string;
    font_size: string;
    placeholder: string;
  };
  buttonType?: {
    form: string;
    size: string;
    animation: string;
  };
  phoneFormState: PhoneFormData;
  onSubmit: (data: PhoneFormData) => void;
  nameField?: boolean;
  additionalAgreement?: { label: string, name: string }
}
	
export const PhoneForm = (props:PhoneFormProps) => {
	const dispatch = useDispatch();
	const { active, button, callTimeFormRegime, struct, phoneInputType, buttonType, phoneFormState, onSubmit, nameField, additionalAgreement } = props;
  const [placeholder, setPlaceholder] = useState(props.placeholder || "Ваш телефон");
  const { error } = useSelector((state: RootState) => state.main);
  const [formPristine, setFormPristine] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [startTyping, setStartTyping] = useState(false);

  const widnowFrom700 = useMediaQuery({ minWidth: 701 });

  useEffect(() => {
    if (phoneInputType?.placeholder && phoneInputType?.placeholder !== "DEFAULT") {
      setPlaceholder(phoneInputType?.placeholder);
    }
  }, [phoneInputType]);

  useEffect(() => {
    if (startTyping) emitEvent(EVENT_START_TYPING_PHONE);
  }, [startTyping]);

  const validateField = useCallback((fieldName: string, value: any) => {
    if (fieldName == "phone") {
      const phoneLength = value ? (value.match(/\d/g) || []).length : 0;
      const phonePattern = /(?:8|\+7) \([^78]\d{2}\) \d{3}-\d{4}/;

      if (!value) {
        dispatch(setError(EMPTY_PHONE_ERROR));
        return false;
      }
      if (phoneLength < PHONE_REQUIRED_LENGTH) {
        dispatch(setError(PHONE_LENGTH_ERROR));
        return false;
      }

      var last7charsAreEqual = (value[15] == value[14]) && (value[14] == value[13]) && (value[13] == value[12]) && (value[12] == value[10]) && (value[10] == value[9]) && (value[9]== value[8]);
      if(value == "" || last7charsAreEqual || !phonePattern.test(value)) {
        dispatch(setError(INCORRECT_PHONE_ERROR));
        return false;
      }
    }

    if (fieldName == "agreement") {
      if (!value) {
        dispatch(setError(AGREEMENT_ERROR));
        return false;
      }
    }

    dispatch(resetError());
    return true;
  }, []);

  const phonePasteHanlder = useCallback((e: React.ClipboardEvent<ReactElement>) => {
    e.preventDefault();
    const number = e.clipboardData.getData("Text");
    const formattedNumber = number.replace(/\+7|7|8/i, '');
    dispatch(phoneFormActions.update({ phone: formattedNumber }));
  }, []);

  const validateAll = useCallback(() => {
    let field: keyof typeof phoneFormState;
    for (field in phoneFormState) {
      if (!validateField(field, phoneFormState[field])) return false; 
    }

    return true;
  }, [phoneFormState]);

  const handleSubmit = useCallback((e: React.FormEvent<HTMLFormElement>) => {
    setButtonDisabled(true);
    e.preventDefault();

    if (validateAll()) onSubmit && onSubmit(phoneFormState);
      else setButtonDisabled(false);

    setFormPristine(false);
  }, [phoneFormState, setFormPristine, setButtonDisabled, validateAll]);

  const onInputChange = useCallback((fieldName: string, value: any) => {
    dispatch(phoneFormActions.update({ [fieldName]: value }));
    if (!formPristine) validateField(fieldName, value);
    setStartTyping(true);
    
  }, [validateField, setStartTyping, formPristine]);

	return (
		<form onSubmit={handleSubmit}>
			<Fade up duration={600} delay={100} when={active}>
        {nameField && <InputField label="Ваше имя" name={"name"} value={phoneFormState.name} mask="" inputType={phoneInputType} noMargin>
          <input id={"name"}
            name={"name"}
            placeholder={"Ваше имя"}
            type="text"
            onChange={e => onInputChange("name", e.currentTarget.value)}
          />
        </InputField>}
				<InputField
					name='phone' 
          label="Ваш телефон"
					placeholder={placeholder}
					type='tel'
					mask={'{8} (000) 000-0000'}
					autoComplete='off'
					theme={struct}
          inputType={phoneInputType}
          onChange={(value: any) => onInputChange("phone", value)}
          onPaste={phonePasteHanlder}
          value={phoneFormState.phone}
				/>
				{struct == "inline" && <Button 
          disabled={buttonDisabled} 
					type='submit' 
					mode={struct == 'inline' ? struct : 'phone-form'} 
					value={button}
				/>}
			</Fade>

			{(callTimeFormRegime == 'loadUnderPhone' || callTimeFormRegime == 'straightUnderPhone') && 
				<Fade up duration={600} delay={200} when={active}>
					<CallTimeUnderPhone regime={callTimeFormRegime} />
				</Fade>
			}

			{(Boolean(error) && widnowFrom700) && <ErrorMessage error={error}/>}

			<Fade right delay={100} duration={500} when={active}>
				{struct != "inline" && <Button type='submit' mode='phone-form' disabled={buttonDisabled} value={button} modifications={buttonType}/>}
        <Agreement 
          name='agreement' 
          onChange={(e:React.ChangeEvent<HTMLInputElement>) => onInputChange("agreement", e.currentTarget.checked)} 
          checked={phoneFormState.agreement}
        />
        {additionalAgreement && <CustomAgreement 
          checked={Boolean(phoneFormState.additionalAgreement)} 
          name={additionalAgreement.name}
          label={additionalAgreement.label}
          id={"additionalAgreement"}
          onChange={(e:React.ChangeEvent<HTMLInputElement>) => onInputChange("additionalAgreement", e.currentTarget.checked)}
        />}
			</Fade>

		</form>
	);
}